(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-car-shell"] && !Shopify.designMode) return;
  try {
    
function initNvCar(scope=document){
 scope.querySelectorAll('.nv-buy:not([data-nv-ready])').forEach(root=>{
  root.dataset.nvReady='true';
  const variants=JSON.parse(root.querySelector('[data-nv-variants]').textContent||'[]'),form=root.querySelector('form'),idInput=root.querySelector('[name="id"]'),button=root.querySelector('.nv-atc'),sticky=root.querySelector('.nv-sticky-atc'),stickySelect=root.querySelector('[data-nv-sticky-pack]'),stickyButton=root.querySelector('[data-nv-sticky-add]');
  const packOf=variant=>String(variant?.options?.[variant.options.length-1]||'').split(' ')[0];
  const linkedId=new URL(window.location.href).searchParams.get('variant');
  const initial=variants.find(v=>String(v.id)===linkedId)||variants.find(v=>String(v.id)===idInput.value);
  if(initial)root.querySelectorAll('[name="nv-pack"]').forEach(input=>input.checked=input.value===packOf(initial));
  idInput.disabled=false;
  const money=cents=>new Intl.NumberFormat('en-US',{style:'currency',currency:window.Shopify?.currency?.active||'USD',maximumFractionDigits:2}).format(cents/100);
  const syncSticky=selected=>{
   if(!sticky||!selected)return;
   const single=variants.find(v=>packOf(v)==='1'),total=Number(packOf(selected))*(single?.price||0),saving=total-selected.price;
   stickySelect.value=String(selected.id);
   sticky.querySelector('[data-nv-sticky-price]').textContent=money(selected.price);
   const compare=sticky.querySelector('[data-nv-sticky-compare]'),savingLabel=sticky.querySelector('[data-nv-sticky-saving]');
   compare.textContent=saving>0?money(total):'';compare.hidden=saving<=0;
   savingLabel.textContent=saving>0?'SAVE '+money(saving):'';savingLabel.hidden=saving<=0;
   stickyButton.disabled=!selected.available;stickyButton.textContent=selected.available?button.dataset.add:button.dataset.unavailable;
  };
  const update=()=>{
   const pack=root.querySelector('[name="nv-pack"]:checked')?.value;
   const single=variants.find(v=>packOf(v)==='1');
   for(const row of root.querySelectorAll('.quantity-break[data-pack]')){
    const variant=variants.find(v=>packOf(v)===row.dataset.pack),radio=root.querySelector('[name="nv-pack"][value="'+row.dataset.pack+'"]');
    radio.disabled=!variant||!variant.available;radio.classList.toggle('disabled',radio.disabled);row.setAttribute('aria-disabled',String(radio.disabled));
    if(!variant){row.querySelector('[data-price]').textContent=button.dataset.unavailable;continue;}
    row.querySelector('[data-price]').textContent=money(variant.price);
    const total=Number(row.dataset.pack)*(single?.price||0),saving=total-variant.price;
    row.querySelector('.quantity-break__compare-price').textContent=saving>0?money(total):'';
    row.querySelector('.quantity-break__benefit')?.replaceChildren(document.createTextNode('SAVE '+money(Math.max(0,saving))));
   }
   const selected=variants.find(v=>packOf(v)===pack);
   idInput.value=selected?.id||'';button.disabled=!selected||!selected.available;
   idInput.disabled=button.disabled;
   button.textContent=selected?.available?button.dataset.add:button.dataset.unavailable;
   const accelerated=root.querySelector('.nv-accelerated-checkout');
   if(accelerated)accelerated.hidden=button.disabled;
   syncSticky(selected);
   idInput.dispatchEvent(new Event('change',{bubbles:true}));
  };
  root.querySelectorAll('[name="nv-pack"]').forEach(input=>input.addEventListener('change',update));update();
  stickySelect?.addEventListener('change',()=>{const selected=variants.find(v=>String(v.id)===stickySelect.value),radio=root.querySelector('[name="nv-pack"][value="'+packOf(selected)+'"]');if(!selected||!selected.available||!radio)return;radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));});
  stickyButton?.addEventListener('click',()=>button.click());
  if(sticky){const syncVisibility=()=>{sticky.hidden=button.getBoundingClientRect().bottom>=0;};window.addEventListener('scroll',syncVisibility,{passive:true});window.addEventListener('resize',syncVisibility,{passive:true});syncVisibility();}
  form.addEventListener('submit',event=>{if(!idInput.value||button.disabled)event.preventDefault();});
  const thumbs=[...root.querySelectorAll('[data-nv-image]')],main=root.querySelector('.nv-main-image');let current=0;
  const choose=i=>{if(!thumbs.length)return;current=(i+thumbs.length)%thumbs.length;main.src=thumbs[current].dataset.nvImage;main.srcset=thumbs[current].dataset.nvSrcset||'';main.alt=thumbs[current].querySelector('img').alt;thumbs.forEach((b,j)=>b.setAttribute('aria-current',j===current?'true':'false'));};
  thumbs.forEach((b,i)=>b.addEventListener('click',()=>choose(i)));root.querySelector('.next')?.addEventListener('click',()=>choose(current+1));root.querySelector('.prev')?.addEventListener('click',()=>choose(current-1));
 });
 scope.querySelectorAll('.nv-module:not([data-nv-carousel-ready])').forEach(root=>{root.dataset.nvCarouselReady='true';const cards=root.querySelector('.nv-cards'),counter=root.querySelector('[data-nv-counter]');if(!cards||!counter)return;root.querySelectorAll('[data-nv-slide]').forEach(b=>b.addEventListener('click',()=>cards.scrollBy({left:Number(b.dataset.nvSlide)*(cards.firstElementChild.getBoundingClientRect().width+16),behavior:'smooth'})));cards.addEventListener('scroll',()=>{const index=Math.round(cards.scrollLeft/(cards.firstElementChild.getBoundingClientRect().width+16))+1;counter.textContent=Math.min(index,cards.children.length)+' / '+cards.children.length;},{passive:true});});
}
initNvCar();document.addEventListener('shopify:section:load',()=>initNvCar());


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-car-stock"] && !Shopify.designMode) return;
  try {
    
function initNvCampaign(scope=document) {
 scope.querySelectorAll('[data-nv-campaign-variant]:not([data-nv-campaign-ready])').forEach(link=>{
  link.dataset.nvCampaignReady='true';
  link.addEventListener('click',event=>{
   const buy=document.querySelector('.nv-buy');
   if(!buy)return;
   const grade=[...buy.querySelectorAll('[name="nv-grade"]')].find(input=>input.value===link.dataset.grade);
   const pack=[...buy.querySelectorAll('[name="nv-pack"]')].find(input=>input.value===link.dataset.pack);
   if(!grade||!pack)return;
   grade.checked=true; grade.dispatchEvent(new Event('change',{bubbles:true}));
   if(pack.disabled)return;
   pack.checked=true; pack.dispatchEvent(new Event('change',{bubbles:true}));
  });
 });
}
initNvCampaign();
document.addEventListener('shopify:section:load',()=>initNvCampaign());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-car-stories"] && !Shopify.designMode) return;
  try {
    
function initNvStories(scope = document) {
 scope.querySelectorAll('[data-nv-stories]:not([data-nv-stories-ready])').forEach(root => {
  root.dataset.nvStoriesReady = 'true';
  const track = root.querySelector('[data-nv-story-track]');
  const cards = [...track.children];
  const prev = root.querySelector('[data-nv-story-prev]');
  const next = root.querySelector('[data-nv-story-next]');
  const dots = root.querySelector('[data-nv-story-dots]');
  let max = 0, index = 0, step = 1;
  const update = () => {
   index = Math.max(0, Math.min(max, Math.round(track.scrollLeft / step)));
   if (prev) prev.disabled = index === 0;
   if (next) next.disabled = index === max;
   dots.querySelectorAll('button').forEach((dot,i) => dot.setAttribute('aria-current', String(i === index)));
  };
  const choose = i => track.scrollTo({left: Math.max(0,Math.min(max,i))*step, behavior: window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  const measure = () => {
   if (!cards.length) return;
   const width = cards[0].getBoundingClientRect().width;
   step = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : width;
   if (!step) step = width || 1;
   const visible = Math.max(1, Math.floor((track.clientWidth + step - width + 1) / step));
   max = Math.max(0, cards.length - visible);
   dots.replaceChildren();
   for (let i=0;i<=max;i++) {
    const dot=document.createElement('button');
    dot.type='button'; dot.dataset.nvStoryDot=String(i);
    dot.setAttribute('aria-label','Show review '+(i+1));
    dot.addEventListener('click',()=>choose(i));
    dots.appendChild(dot);
   }
   dots.hidden=max===0;
   if (prev) prev.hidden=max===0;
   if (next) next.hidden=max===0;
   update();
  };
  prev?.addEventListener('click',()=>choose(index-1));
  next?.addEventListener('click',()=>choose(index+1));
  track.addEventListener('scroll',update,{passive:true});
  track.addEventListener('keydown',event=>{
   if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();choose(index+(event.key==='ArrowRight'?1:-1));}
  });
  window.addEventListener('resize',measure);
  if (window.ResizeObserver) new ResizeObserver(measure).observe(track);
  measure();
 });
}
initNvStories();
document.addEventListener('shopify:section:load',()=>initNvStories());

  } catch(e) { console.error(e); }
})();
})();
